import { SvgIcon } from '@mui/material'

const HomeIcon = () => (
  <SvgIcon>
    <path d="M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69M12 3L2 12H5V20H11V14H13V20H19V12H22L12 3Z" />
  </SvgIcon>
)

export default HomeIcon
